
import axios from "axios"
import ApiStore from "./ApiStore";
// var querystring = require('querystring');


export class AccountSettingsStore extends ApiStore{
  constructor() {
    super();
    this.state = {}
  }

  loadCompanyInfo(completeFunc){
    
    axios.get('/accountsettings/company_info')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  
  }

  saveCompanyInfo(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/accountsettings/company_info',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  } 
  
  loadDocumentNumberFormat(completeFunc){
    
    axios.get('/accountsettings/document_number_format')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  
  }

  saveDocumentNumberFormat(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/accountsettings/document_number_format',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  } 

  loadDocumentPrint(completeFunc){
    
    axios.get('/accountsettings/document_print')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  
  }

  saveDocumentPrint(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/accountsettings/document_print',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  } 

  loadConfigMenu(bf_role_id,completeFunc){
    
    axios.get('/accountsettings/config_menu'+(bf_role_id===''?'':'/'+bf_role_id))
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  
  }

  saveConfigMenu(bf_role_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/accountsettings/config_menu'+(bf_role_id===''?'':'/'+bf_role_id),postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadPermMenu(completeFunc){
    
    axios.get('/accountsettings/perm_menu')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  
  }
}

export default new AccountSettingsStore()



// WEBPACK FOOTER //
// ./src/stores/AccountSettingsStore.js